<!--
2023-06-02 ytw
-->
<template>
  <div class="pop-confirm">
    <div class="close_mask" @click="closeDiscount"></div>
    <div class="background-content">
      <div class="toolBox">
        <div class="white-fonts">
          <span>{{ $t('lang.WelfareDeposit.discount1') }}</span>
        </div>
        <div class="gray-fonts">
          {{ $t('lang.WelfareDeposit.discount2') }}
        </div>
      </div>
      <div class="gift-list">
        <div class="gift-row" v-for="(item, index) in discountList" :key="index">
          <div class="content-box">
            <div class="dueDate">
              {{ item.DueDate }}
            </div>
            <div class="type-content">
              <div class="imageOuter">
                <img :src="coin" v-if="item.GiftType==='gift'" alt="coin">
                <img :src="card" v-if="item.GiftType==='discount'" alt="card" style="rotate: -5deg">
              </div>
              <div class="gift-text" v-if="item.GiftType==='gift'">
                <div class="text-right">+{{ $t('lang.account.currencyType') }}{{ item.GiftAmount }}</div>
              </div>
              <div class="gift-text" v-if="item.GiftType==='discount'">
                <div class="text-right">{{ $t('lang.luckyWheel.deposit') }} +{{ item.Discount }}%</div>
              </div>
            </div>
          </div>
          <div class="btn-box">
            <div class="use" v-if="item.Status===10" @click="toDeposit(item)">{{ $t('lang.luckyWheel.use') }}</div>
            <div class="received" v-if="(item.Status===20||item.Status===30)&&item.GiftType==='gift'">{{ $t('lang.luckyWheel.received') }}</div>
            <div class="done" v-if="(item.Status===20||item.Status===30)&&item.GiftType==='discount'">{{ $t('lang.luckyWheel.used') }}</div>
            <div class="done" v-if="item.Status===40&&item.GiftType==='discount'">{{ $t('lang.luckyWheel.expire') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import coin from '@/assets/images/wheel/coin.png'
import card from '@/assets/images/wheel/card.png'
export default {
  name: 'wheelDiscount',
  props: [
    'discountList',
    'closeDiscount',
    'userInfo'
  ],
  data () {
    return {
      coin,
      card
    }
  },
  methods: {
    toDeposit (item) {
      this.closeDiscount()
      this.$router.push({name: 'Deposit', query: {guid: item.GiftUuid}}) // 告知充值页面使用充值赠券
    }
  }
}
</script>

<style lang="less" scoped>
.pop-confirm {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, .6);
  z-index: 990;
  box-sizing: border-box;
  overflow: auto;
  display: flex;
  flex-flow: column;

  .close_mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.2);
  }

  .background-content {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 86.667vw;
    height: 88.889vw;
    background: #181818;
    border-radius: 2.222vw;

    .toolBox {
      position: relative;
      top: 6vw;
      left: 50%;
      transform: translate(-50%);
      text-align: left;

      .white-fonts {
        position: relative;
        left: 50%;
        transform: translate(-50%);
        font-family: Inter;
        font-size: 5vw;
        font-weight: 600;
        text-align: center;
        width: 61.944vw;
        color: #FFFFFF;
      }

      .gray-fonts {
        margin-top: 1vw;
        font-family: Inter;
        font-size: 3.333vw;
        font-weight: 400;
        text-align: center;
        color: #838383;
      }
    }

    .gift-list {
      position: relative;
      margin-top: 10.5vw;
      width: 76.667vw;
      height: 51vw;
      left: 50%;
      transform: translate(-50%);
      overflow-x: hidden;
      overflow-y: auto;

      .gift-row {
        display: flex;
        justify-content: space-between;
        width: 76.667vw;
        height: 14.722vw;
        border-radius: 2.222vw;
        background: #272727;
        margin-bottom: 3.333vw;
        padding-right: 3.05vw;

        .content-box {
          width: 31.111vw;

          .type-content {
            display: flex;
            height: 5.8333vw;
            margin-top: 1.388vw;

            .imageOuter {
              display: flex;
              justify-content: center;
              width: 8.1vw;
              margin: 0 2.45vw;

              img {
                height: 5.8333vw;
                width: auto;
              }
            }

            .gift-text {
              display: flex;
              white-space: nowrap;
              font-family: Inter;
              font-size: 3.888vw;
              font-weight: 500;
              text-align: center;
              color: #F1DAB0;
              margin-top: 0.5vw;

              .text-right {
                width: max-content;
                text-align: right;
              }
            }
          }

          .dueDate {
            margin-left: 2.5vw;
            margin-top: 1.694vw;
            font-family: Inter;
            font-size: 3.055vw;
            font-weight: 500;
            text-align: left;
            color: #6F6F6F;
          }
        }

        .btn-box {
          width: 22.5vw;

          div {
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            text-align: center;
            width: 100%;
            height: 6.388vw;
            line-height: 6.388vw;
            font-family: Inter;
            font-size: 2.778vw;
            font-weight: 600;
            border-radius: 1.111vw;
          }

          .use {
            background: #F1DAB0;
            color: #000000;
          }

          .received {
            border: 0.2777vw solid #F1DAB0;
            color: #F1DAB0;
          }

          .done {
            border: 0.2777vw solid #575757;
            color: #878787;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Wheel/discount.vue